import { render, staticRenderFns } from "./DeleteRole.vue?vue&type=template&id=dc1078a6&"
import script from "./DeleteRole.vue?vue&type=script&lang=js&"
export * from "./DeleteRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports